import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { OnboardingProgressBanner } from "~/components/ui/onboarding-progress-banner";
import { PageHeader } from "~/components/ui/page-title";
import { Tab, TabList } from "~/components/ui/tabs";
import { useCoachPrivateProfileRequired } from "~/contexts/coach";

export const Route = createFileRoute("/_user/my-coaching/profile")({
  staticData: { title: "Coach profile" },
  // Every coach works here from the day she registers, including one under
  // review. A revoked coach goes to the dashboard, which shows her revoked
  // access.
  beforeLoad: ({ context }) => {
    if (context.isRevoked) {
      throw redirect({ to: "/my-coaching/clients/dashboard" });
    }
  },
  component: ProfileLayout,
});

function ProfileTabs(): React.JSX.Element {
  return (
    <TabList className="w-full">
      <Tab to="/my-coaching/profile/personal-info">Personal info</Tab>
      <Tab to="/my-coaching/profile/bio">Profile & bio</Tab>
      <Tab to="/my-coaching/profile/offers">Offers</Tab>
      <Tab to="/my-coaching/profile/qualifications">Qualifications</Tab>
      <Tab to="/my-coaching/profile/testimonials">Testimonials</Tab>
      <Tab to="/my-coaching/profile/details">Matching details</Tab>
    </TabList>
  );
}

function ProfileLayout() {
  useCoachPrivateProfileRequired();

  return (
    <div className="space-y-8">
      <ProfileTabs />
      <PageHeader
        title="My coach profile"
        description="Manage your coaching profile, offers, and qualifications."
      />
      <OnboardingProgressBanner />
      <Outlet />
    </div>
  );
}
